import styled from 'styled-components';
import { Colors, FInter, FlexBox } from '@brg/ui';

export const SlideNavigationWrapper = styled(FlexBox)`
    flex-direction: column;
    width: 100%;
`;

export const SlideNavigationWrapperItem = styled(FInter.SmallTextBoldFlex)<{ active: boolean }>`
    color: ${(p) => (p.active ? p.theme.designerPage.slideLine : p.theme.designerPage.slideLineInActive)};
    cursor: pointer;
    transition: all 0.2s;
    padding: 8px 0;
    border-bottom: 1px solid ${Colors.galBlack21};
    width: 100%;
`;

export const FlexColumn = styled.div`
    display: flex;
    flex-direction: column;
`;
import styled from 'styled-components';
import { Colors, FInter, FlexBox } from '@brg/ui';

export const SlideNavigationWrapper = styled(FlexBox)`
    flex-direction: column;
    width: 100%;
`;

export const SlideNavigationWrapperItem = styled(FInter.SmallTextBoldFlex)<{ active: boolean }>`
    color: ${(p) => (p.active ? p.theme.designerPage.slideLine : p.theme.designerPage.slideLineInActive)};
    cursor: pointer;
    transition: all 0.2s;
    padding: 8px 0;
    border-bottom: 1px solid ${Colors.galBlack21};
    width: 100%;
`;

export const FlexColumn = styled.div`
    display: flex;
    flex-direction: column;
`;
